import { Download } from 'lucide-react';
import React, { useState } from 'react';

/**
 * Triggers a pull of RRA's real item classification catalog (via
 * selectItemsClass against the local VSDC) into ebm_item_classifications —
 * shared by both fiscal-setup pages since either one may be the first place
 * an admin notices the classification picker is empty.
 */
export function SyncItemClassesButton({
  onSync,
}: {
  onSync: () => Promise<void>;
}) {
  const [isSyncing, setIsSyncing] = useState(false);

  const handleClick = async () => {
    setIsSyncing(true);
    try {
      await onSync();
    } finally {
      setIsSyncing(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={isSyncing}
      title="Pull the real RRA item classification catalog from the local VSDC device."
      className="flex items-center gap-1.5 rounded-lg border border-gray-200 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-60"
    >
      <Download size={14} className={isSyncing ? 'animate-pulse' : ''} />
      {isSyncing ? 'Syncing…' : 'Sync Classification Codes'}
    </button>
  );
}
